import { Meat } from "./Meat";
import { TServiceResult } from "./TServiceResult";
import { VentLog } from "./VentLog";
import { RexDateTime } from "../Dates/RexDateTime";

export class SmokeFull
{
    SmokeID: string = "";
    UserID: string = "";
    Tenant: string = "";
    Description: string = "";
    Date: RexDateTime | Date = new RexDateTime(0);
    Weather: string = "";
    Meats: Meat[] = [];
    VentLog: VentLog[] = [];
    BuriedWood: string = "";
    FloatWood: string = "";
    Charcoal: string = "";
    SmokerPrep: string = "";
}

export type ServiceSmokeFull = TServiceResult<SmokeFull>;

export const EmptyServiceSmokeFull: ServiceSmokeFull =
{
    TheValue: new SmokeFull(),
    Result: false,
    Reason: "Not initialized",
    CorrelationID: "",
    Succeeded: false
}